import React, { useEffect, useState } from "react";
import { inr } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { CreditCard } from "lucide-react";

const WA = { sent: "WhatsApp sent", failed: "WhatsApp failed", whatsapp_off: "WhatsApp off" };

export const OnlinePayments = ({ client, period, date }) => {
  const [d, setD] = useState({ rows: [], paid_count: 0, paid_total: 0 });
  useEffect(() => { client.get("/accounts/online-payments", { params: { period, date } }).then((r) => setD(r.data)).catch(() => {}); }, [client, period, date]);
  return (
    <Card className="bg-card/40 border-gold/20 p-5 mt-6" data-testid="online-payments">
      <div className="flex flex-wrap items-center justify-between gap-2 mb-3">
        <p className="eyebrow text-gold flex items-center gap-1.5"><CreditCard className="w-4 h-4" /> Online payments (Razorpay)</p>
        <p className="text-sm text-white" data-testid="online-payments-total">{d.paid_count} paid · <span className="text-emerald-300 font-semibold">{inr(d.paid_total)}</span></p>
      </div>
      <div className="overflow-x-auto max-h-96 overflow-y-auto">
        <table className="w-full text-sm">
          <thead className="sticky top-0 bg-[#05261D]"><tr className="text-left">
            {["Date", "Payer", "For", "Amount", "Status", "Payment ID", "Receipt"].map((h) => <th key={h} className="eyebrow text-gold px-2 py-2 border-b border-gold/30 whitespace-nowrap">{h}</th>)}
          </tr></thead>
          <tbody>
            {d.rows.map((r) => (
              <tr key={r.order_id} className="border-b border-border/40" data-testid={`online-pay-row-${r.order_id}`}>
                <td className="px-2 py-2 text-xs whitespace-nowrap">{new Date(r.date).toLocaleString("en-IN", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" })}</td>
                <td className="px-2 py-2 text-xs text-white">{r.payer}<span className="block text-[10px] text-muted-foreground">{r.phone}</span></td>
                <td className="px-2 py-2 text-xs text-muted-foreground">{r.for}</td>
                <td className="px-2 py-2 font-semibold whitespace-nowrap">{inr(r.amount)}</td>
                <td className="px-2 py-2 text-xs"><span className={`rounded-full px-2 py-0.5 border ${r.status === "paid" ? "border-emerald-400/40 text-emerald-300" : "border-border text-muted-foreground"}`}>{r.status === "paid" ? "Paid" : "Not completed"}</span></td>
                <td className="px-2 py-2 text-[10px] font-mono text-muted-foreground">{r.payment_id || "—"}</td>
                <td className="px-2 py-2 text-[10px] text-muted-foreground">{WA[r.receipt_whatsapp] || "—"}</td>
              </tr>
            ))}
            {d.rows.length === 0 && <tr><td colSpan={7} className="px-2 py-6 text-center text-xs text-muted-foreground">No online payments in this period.</td></tr>}
          </tbody>
        </table>
      </div>
    </Card>
  );
};
